import React, {useState, useContext, useRef, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {
  DataTable,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,  
  TableSelectRow,  
} from 'carbon-components-react';
import TableMenu from "../../components/TableMenu/TableMenu";
import MessageModal from '../../components/MessageModal/MessageModal';
import { Account, ChangeCatalog, AddAlt, SubtractAlt,TrashCan,DocumentAttachment } from '@carbon/icons-react';
import {elegirDoc } from '../../services/services';
import SessionController from '../../components/FrontSessionController/SessionController';
import {ThemeContext} from '../../context/ThemeProvider';

const HomeTable = ({ rows, headers, getAllDocumentsCallback, processDocsResponseCallback3 }) => {
  
  const navigate = useNavigate();
  const theme = useContext(ThemeContext);
  const userType = theme.theme.userType;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  //start use state for TableMenu and all the invoice table
  const [rowsSelectedFromAllInvoiceTable, setRowsSelectedFromAllInvoiceTable] = useState([]);
   //for modal error or information use
   const [messageModal, setMessageModal] = useState('');
   const messageResponse = useRef([]);  
   const [idDoc, setIdDoc] = useState(0);
   const [firstDoc, setFirstDoc] = useState([]);
   //for showing message and making cursong round for request
  const processingRequest = useRef(false);
  const [messageSessionLost, setMessageSessionLost] = useState('');

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }  

  const goToDocumentView = (idDoc) => {      
    getAllDocument(idDoc);     
  };

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  const getAllDocument = async (idDoc) => { 
    if(isRequestActive(true)){
      return;
    } 
    await elegirDoc(idDoc)
      .then(response => {
        if(response.status === 200){
          setIdDoc(parseInt(idDoc));
          if(response.status === 200) {
            console.log(200)           
          }
          navigate('/document-view');
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        } else{
          response.text()
            .then(response => {            
              openMessageModal(response);
          })
        } 
      })                   
    isRequestActive(false);
  };
  
  const handleCheckBoxSelected = (row) => {
    let newRowsSelectedFromAllInvoiceTable = [...rowsSelectedFromAllInvoiceTable];
    let elementPosition = newRowsSelectedFromAllInvoiceTable.map(element => element.id).indexOf(row.id);
    if(elementPosition == -1 && !row.isSelected){
      newRowsSelectedFromAllInvoiceTable.push(row);
    }else if(row.isSelected){
      newRowsSelectedFromAllInvoiceTable.splice(elementPosition,1);
    }
    setRowsSelectedFromAllInvoiceTable(newRowsSelectedFromAllInvoiceTable);
  }
  const getAllDocumentsCallback2 = () => {
    resetCheckBoxFromInvoiceTable();
    getAllDocumentsCallback();
  }

  const resetCheckBoxFromInvoiceTable = () => {
    setRowsSelectedFromAllInvoiceTable([])
  }
  const processDocResponseCallback2 = (response) => {
    processDocsResponseCallback3(response);
  }
  
    
  return (
    <>   
    <DataTable
      
      rows={rows}
      headers={headers}
      isSortable
      render={({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getTableProps,
        getSelectionProps,
        onInputChange,
        
      }) => (
        <TableContainer className={'table-container'}>
          <TableMenu 
            rowsSelectedFromAllInvoiceTableCallback={rowsSelectedFromAllInvoiceTable} 
            getAllDocumentsCallback3={getAllDocumentsCallback2} 
            processDocsResponseCallback={processDocResponseCallback2}/>
          <TableToolbar>
            <TableToolbarContent>
              <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
              
            </TableToolbarContent>
          </TableToolbar>
          <Table {...getTableProps()} useZebraStyles>
            <TableHead>
              <TableRow>
                {<TableHeader key={"checkboxkey"}/>}
                {headers.map(header => (
                  <>
                  {header.key === "idDoc" ? (
                    <TableHeader key={header.key} {...getHeaderProps({header})} {...getSelectionProps({ header })}>                    
                    </TableHeader>
                  ):(
                    <TableHeader key={header.key} {...getHeaderProps({header})} {...getSelectionProps({ header })} >
                    {header.header}
                  </TableHeader>
                  )}                  
                  </>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>                
              {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row) => (
                <>
                <TableRow  {...getRowProps({ row })}>                    
                  <TableSelectRow  {...getSelectionProps({ row })} onChange={() => handleCheckBoxSelected(row)}/>
                  {row.cells.map(cell => (  
                    <>
                    {cell.id == "".concat(row.id, ":idDoc") ? (
                      <TableCell className="classTableHeaderHidden" 
                        onClick={() => goToDocumentView(userType.includes('privilegedUser')? row.cells[15].value : row.cells[13].value)} 
                        key={cell.id}>{cell.value}</TableCell>
                    ):(
                      <TableCell onClick={() => goToDocumentView(userType.includes('privilegedUser')? row.cells[15].value : row.cells[13].value)} 
                      key={cell.id}>{cell.value}</TableCell>
                    )}                    
                    </>
                  ))}
                </TableRow>
                  </>
              ))}
            </TableBody>
          </Table>
          <Pagination
            onChange={changePaginationState}
            backwardText="Previous page"
            forwardText="Next page"
            itemsPerPageText="Items per page:"
            page={page}
            pageNumberText="Page Number"
            pageSize={pageSize}
            pageSizes={[
              10,
              25,
              50,
              100,
            ]}
            totalItems={rows.length}
          />          
        </TableContainer>
      )}
    /> 
    <SessionController messageLostSessionCallback={messageSessionLost} />
    <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
    </>
  );
};

export default HomeTable;